import { render } from "./CategoryForm.vue?vue&type=template&id=a85621c8&scoped=true"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"

import "./CategoryForm.vue?vue&type=style&index=0&id=a85621c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85621c8"]])

export default __exports__